import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CorporateTestimonials = () => {
  const testimonials = [
  {
    id: 1,
    company: 'TechVision Solutions',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1271425cd-1764538640208.png",
    logoAlt: 'Modern technology company logo with blue and white geometric design on professional business card',
    contactName: 'Sarah Mitchell',
    position: 'Director of Operations',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_141b6fda2-1763295319855.png",
    avatarAlt: 'Professional headshot of confident woman with shoulder-length brown hair wearing navy blazer and pearl necklace',
    rating: 5,
    testimonial: 'Montesanto has been our go-to catering partner for three years. Their attention to detail and authentic Italian flavors consistently impress our clients and team. The breakfast service for our weekly meetings is always fresh and beautifully presented.',
    eventsHosted: 48,
    image: "https://images.unsplash.com/photo-1714700167450-19c1ca2350a8",
    imageAlt: 'Corporate conference room with elegant Italian catering spread featuring sandwiches and pastries on white tablecloths with business professionals networking in background'
  },
  {
    id: 2,
    company: 'Meridian Financial Group',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_10591d966-1764538640507.png",
    logoAlt: 'Sophisticated financial services company logo with gold and navy color scheme on premium letterhead',
    contactName: 'David Chen',
    position: 'Senior Partner',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_183233d26-1763293485515.png",
    avatarAlt: 'Professional headshot of Asian businessman with short black hair wearing charcoal suit and burgundy tie',
    rating: 5,
    testimonial: 'When we host client appreciation events, presentation matters. Montesanto delivers excellence every time. Their catering elevates our events and reflects the quality standards we uphold. The custom dessert bar was a highlight at our annual gala.',
    eventsHosted: 32,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bf6b3ffe-1764538652992.png",
    imageAlt: 'Upscale corporate event with Italian dessert bar featuring tiramisu and cannoli elegantly displayed on marble counters with crystal glassware'
  },
  {
    id: 3,
    company: 'Greenleaf Architecture',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_11d370019-1764538640175.png",
    logoAlt: 'Contemporary architecture firm logo with green leaf design and minimalist typography on white background',
    contactName: 'Emily Rodriguez',
    position: 'Managing Director',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14652f2bb-1763296569890.png",
    avatarAlt: 'Professional headshot of Hispanic woman with long dark hair wearing emerald green blouse and silver jewelry',
    rating: 5,
    testimonial: 'Our firm values sustainability and quality. Montesanto shares these values with their fresh, locally-sourced ingredients and minimal waste approach. Their lunch catering for our design charrettes keeps our team energized and creative.',
    eventsHosted: 24,
    image: "https://images.unsplash.com/photo-1580804324047-aec6acb09061",
    imageAlt: 'Modern office lunch setup with Italian sandwiches and salads arranged on eco-friendly serving platters with natural lighting from large windows'
  },
  {
    id: 4,
    company: 'Horizon Healthcare',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_189f465a7-1764538640477.png",
    logoAlt: 'Healthcare organization logo with blue cross symbol and professional medical typography on white background',
    contactName: 'Dr. James Patterson',
    position: 'Chief Medical Officer',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_111159e52-1763300946900.png",
    avatarAlt: 'Professional headshot of mature doctor with gray hair and glasses wearing white medical coat with stethoscope',
    rating: 5,
    testimonial: 'For our medical conferences and staff appreciation events, we need reliable catering that accommodates dietary restrictions. Montesanto handles everything seamlessly, from gluten-free options to vegetarian selections. Their professionalism is unmatched.',
    eventsHosted: 56,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_15b70d611-1764538642098.png",
    imageAlt: 'Healthcare facility conference with Italian catering buffet featuring healthy options and dietary-friendly selections on stainless steel serving stations'
  }];


  const clientLogos = [
  {
    name: 'Royal Bank Tower',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_112787dbe-1764538645164.png",
    logoAlt: 'Banking institution logo with royal crown emblem and gold lettering on dark blue background'
  },
  {
    name: 'Maple Leaf Properties',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1c1cd0549-1764538640754.png",
    logoAlt: 'Real estate company logo with red maple leaf icon and modern sans-serif typography'
  },
  {
    name: 'Quantum Legal',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_14d573eaa-1764538640481.png",
    logoAlt: 'Law firm logo with scales of justice symbol and traditional serif font in navy and gold'
  },
  {
    name: 'Nexus Consulting',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_112e779b1-1764538639732.png",
    logoAlt: 'Consulting firm logo with interconnected nodes design and contemporary blue gradient'
  },
  {
    name: 'Pinnacle Insurance',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1af8167fa-1764538640862.png",
    logoAlt: 'Insurance company logo with mountain peak symbol and bold uppercase lettering'
  },
  {
    name: 'Velocity Marketing',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_15e2a33ff-1764538640518.png",
    logoAlt: 'Marketing agency logo with dynamic arrow design and vibrant orange and purple colors'
  }];


  return (
    <section className="py-16 bg-card">
      <div className="container-custom">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 mb-4">
            <Icon name="Award" size={18} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">Trusted by Leading Organizations</span>
          </div>
          <h2 className="font-serif text-4xl font-bold text-foreground mb-4">
            Corporate Client Success Stories
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover why Toronto's top businesses choose Montesanto for their catering needs
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {testimonials?.map((testimonial) =>
          <div
            key={testimonial?.id}
            className="bg-background rounded-2xl shadow-warm overflow-hidden hover:shadow-warm-lg transition-all duration-300">

              <div className="h-48 overflow-hidden">
                <Image
                src={testimonial?.image}
                alt={testimonial?.imageAlt}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />

              </div>

              <div className="p-8">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-4">
                    <div className="w-16 h-16 rounded-lg overflow-hidden border-2 border-primary/20">
                      <Image
                      src={testimonial?.logo}
                      alt={testimonial?.logoAlt}
                      className="w-full h-full object-cover" />

                    </div>
                    <div>
                      <h3 className="font-semibold text-lg text-foreground">
                        {testimonial?.company}
                      </h3>
                      <div className="flex items-center gap-1 mt-1">
                        {[...Array(testimonial?.rating)]?.map((_, i) =>
                      <Icon key={i} name="Star" size={16} color="var(--color-warning)" />
                      )}
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-bold text-primary">
                      {testimonial?.eventsHosted}+
                    </div>
                    <div className="text-xs text-muted-foreground">Events</div>
                  </div>
                </div>

                <p className="text-muted-foreground mb-6 leading-relaxed">
                  "{testimonial?.testimonial}"
                </p>

                <div className="flex items-center gap-3 pt-6 border-t border-border">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <Image
                    src={testimonial?.avatar}
                    alt={testimonial?.avatarAlt}
                    className="w-full h-full object-cover" />

                  </div>
                  <div>
                    <div className="font-semibold text-foreground">
                      {testimonial?.contactName}
                    </div>
                    <div className="text-sm text-muted-foreground">
                      {testimonial?.position}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="bg-background rounded-2xl shadow-warm p-8">
          <h3 className="font-serif text-2xl font-bold text-foreground text-center mb-8">
            Proud to Serve Toronto's Leading Organizations
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {clientLogos?.map((client, index) =>
            <div
              key={index}
              className="flex items-center justify-center p-4 bg-card rounded-lg hover:shadow-warm transition-all duration-300 grayscale hover:grayscale-0">

                <Image
                src={client?.logo}
                alt={client?.logoAlt}
                className="w-full h-16 object-contain" />

              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default CorporateTestimonials;